import {Component} from '@angular/core';
import {WizardPageBaseComponent} from '@utils-lib';
import {FestsetzungAngaben} from '@nachdigal';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'common-ui-festsetzung-angaben',
  templateUrl: './festsetzung-angaben.component.html',
  styleUrls: ['./festsetzung-angaben.component.scss']
})
export class FestsetzungAngabenComponent extends WizardPageBaseComponent<FestsetzungAngaben> {

  static nutzdatenPath = 'festsetzungAngaben';
  static route = 'festsetzung-angaben';

  constructor(protected readonly activatedRoute: ActivatedRoute) {
    super(activatedRoute);
  }

  protected getStammdatenMappingRules(): Map<string, unknown> {
    return new Map<string, unknown | Array<unknown>>([]);
  }

}
